import React from 'react';

import './SpotlightsSkeleton.scss';

// Lightweight skeleton primitives for the Spotlights dashboard. All pulse via the shared
// `sl-pulse` keyframes (defined in Spotlights.scss) so loading states fade gently instead
// of flashing a spinner. Used for first loads; in-place refetches (e.g. the 7/30/lifetime
// toggle) keep the existing content and pulse it via the `.sl-refreshing` wrapper.

export const Skeleton = ({ w = '100%', h = 14, r = 8, style }) => (
  <span className='sl-skeleton' style={{ width: w, height: typeof h === 'number' ? `${h}px` : h, borderRadius: r, ...style }} />
);

export const SkeletonCard = () => (
  <div className='sl-card'>
    <Skeleton w='55%' h={11} style={{ marginBottom: 14 }} />
    <Skeleton w='70%' h={28} />
  </div>
);

export const SkeletonCards = ({ count = 6 }) => (
  <div className='sl-card-grid'>
    {Array.from({ length: count }).map((_, i) => (
      <SkeletonCard key={i} />
    ))}
  </div>
);

export const SkeletonLines = ({ count = 4, height = 14 }) => (
  <div className='sl-skeleton-lines'>
    {Array.from({ length: count }).map((_, i) => (
      <Skeleton key={i} h={height} w={`${92 - i * 9}%`} />
    ))}
  </div>
);

export const SkeletonTable = ({ rows = 8, cols = 6 }) => (
  <div className='sl-skeleton-table'>
    {Array.from({ length: rows }).map((_, r) => (
      <div className='sl-skeleton-row' key={r}>
        {Array.from({ length: cols }).map((_, c) => (
          <Skeleton key={c} h={14} w={c === 0 ? '50%' : '72%'} />
        ))}
      </div>
    ))}
  </div>
);

export default Skeleton;
